module.exports = __webpack_public_path__ + "Dashboard-Category.png?1de209aac4194153e6d2c6cf4f67ee54";


//////////////////
// WEBPACK FOOTER
// ./static/Dashboard-Category.png
// module id = 330
// module chunks = 0